/*----------------------------------
- PRICING: SEARCH METADATA
----------------------------------*/

/**
 * @docs docs/features/website-seo-performance
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { PRICING_PLAN_CATALOG, PUBLIC_PLAN_FACTS } from '@uniquedomains/components/pricing/catalogs/pricingPlans';
import { REFUND_GUARANTEE_DAYS } from '@uniquedomains/components/pricing/catalogs/refundPromise';

/*----------------------------------
- CATALOG
----------------------------------*/

const PAID_PLAN_NAME = PRICING_PLAN_CATALOG.member.marketingTagShort;
const MEMBER_FACTS = PUBLIC_PLAN_FACTS.member;

/** The pricing page's one-sentence summary: its meta description and its JSON-LD both read it (R17). */
export const PRICING_PLAN_SUMMARY_SENTENCE = `${PAID_PLAN_NAME} is $${MEMBER_FACTS.price} a month with every feature: ${MEMBER_FACTS.analysesPerMonth} domain analyses a month, ${MEMBER_FACTS.radars} radars and CSV exports. Cancel anytime, money back within ${REFUND_GUARANTEE_DAYS} days.`;

/**
 * `/pricing` used to set no title or description, so it served the Home defaults from
 * `identity.config.ts` and search engines saw two pages with the same title. Every figure
 * is read from `PUBLIC_PLAN_FACTS`, the same record the cards and `/ai/pricing.md` use, so
 * a price or allowance change cannot leave a stale number in the search result.
 */
export const PRICING_PAGE_SEO = {
    title: `Unique Domains Pricing: One Plan, $${PUBLIC_PLAN_FACTS.member.price} a Month`,
    // One plan since ADR-0083 (the free one is retired): the description states the plan, its limits as
    // things, and the refund that stands in for a trial.
    description: PRICING_PLAN_SUMMARY_SENTENCE,
} as const;
